module.exports = __webpack_public_path__ + "static/img/2025_phase_function_Paper_Points.178ad84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2025_phase_function_Paper_Points.png
// module id = sKp6
// module chunks = 0